import { FC, ReactNode } from 'react'
import { ActionDropdown } from './ActionDropdown'
import { MembershipProfileAvatar, MembershipProfileAvatarType } from './Avatar'
import { CardNumberChanger, CardNumberChangerType } from './CardNumberChanger'
import {
  ComplementaryItemSection,
  ComplementaryItemSectionType,
} from './ComplementaryItemsSection'
import {
  MembershipProfileDescription,
  MembershipProfileDescriptionType,
} from './Description'
import {
  EventParticipations,
  EventParticipationsType,
} from './EventParticipations'
import { TagManager, TagManagerType } from './TagManager'
import WalletDisclaimer from './WalletDisclaimer'

const MembershipProfile: FC &
  MembershipProfileAvatarType &
  MembershipProfileDescriptionType &
  CardNumberChangerType &
  TagManagerType &
  ComplementaryItemSectionType &
  EventParticipationsType & {
    WalletDisclaimer: typeof WalletDisclaimer
    ActionDropdown: typeof ActionDropdown
  } = (): ReactNode => <></>

MembershipProfile.Avatar = MembershipProfileAvatar
MembershipProfile.Description = MembershipProfileDescription
MembershipProfile.CardNumberChanger = CardNumberChanger
MembershipProfile.EventParticipations = EventParticipations
MembershipProfile.TagManager = TagManager
MembershipProfile.WalletDisclaimer = WalletDisclaimer
MembershipProfile.ComplementaryItemSection = ComplementaryItemSection
MembershipProfile.ActionDropdown = ActionDropdown

export default MembershipProfile
